import { render } from "./ObjectCard.vue?vue&type=template&id=95888af2&scoped=true"
import script from "./ObjectCard.vue?vue&type=script&lang=js"
export * from "./ObjectCard.vue?vue&type=script&lang=js"

import "./ObjectCard.vue?vue&type=style&index=0&id=95888af2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95888af2"]])

export default __exports__